import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const AdditionalInfo = styled('div', { label: 'AdditionalInfo' })`
    font-size: 12px;
`;

export const InfoTitle = styled('span', { label: 'InfoTitle' })`
    font-weight: ${fontWeight.bold};
`;

export const Title = styled('div', { label: 'Title' })`
    font-size: 20px;
    font-weight: ${fontWeight.bold};
    margin-bottom: 15px;
    color: ${mainColors.default.dark};
`;

export const DescWrapper = styled('div', { label: 'DescWrapper' })``;

export const DataColumn = styled('div', { label: 'DataColumn' })`
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
`;
